var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Grid from "@mui/material/Grid";
import React, { useEffect, useRef, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { usePictureSets } from "@/react/Webshop/hooks/usePictureSets";
import { webshopUserImageUrlCreator } from "@/react/lib/userImageUrlCreators";
import IconButton from "@mui/material/IconButton";
import { useAuth } from "@/react/Webshop/providers/AuthProvider";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { useFullscreenImage } from "@/react/Webshop/Mobile/hooks/useFullscreenImage";
import FullscreenImageDialog from "@/react/Webshop/Mobile/Components/FullscreenImageDialog";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles((theme) => ({
    root: {
        // Note: Have to be bigger than the fixed next button
        paddingBottom: 48 + theme.spacing(2),
    },
    list: {
        width: "100%",
        overflow: "auto",
        alignItems: "center",
        listStyle: "none",
        margin: 0,
        padding: 0,
        flexGrow: 1,
        display: "flex",
    },
    listItem: {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& > img": {
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
            border: `1px solid ${theme.palette.primary.main}`,
            backgroundColor: "white",
        },
    },
}));
const UserSubjectFavoritePicturesSelector = ({ pictureSet, pictureContextMenuProps, }) => {
    const { user } = useAuth();
    const classes = useStyles();
    const { toggleUserFavoritePicture } = usePictureSets();
    const lastSetUuid = useRef(null);
    const [pictures, setPictures] = useState([]);
    const { open, fullscreenImage, origin, openImage, closeImage, updatePicture, } = useFullscreenImage();
    const [t] = useTranslation();
    useEffect(() => {
        updatePicture(pictureSet.pictures);
    }, [pictureSet.pictures]);
    useEffect(() => {
        if (pictureSet.subject.uuid !== lastSetUuid.current) {
            setPictures(pictureSet.pictures);
            lastSetUuid.current = pictureSet.subject.uuid;
        }
    }, [pictureSet.subject.uuid, pictureSet.pictures]);
    useEffect(() => {
        if (pictureSet.subject.uuid === lastSetUuid.current) {
            setPictures((prev) => prev.map((localPic) => {
                const updated = pictureSet.pictures.find((p) => p.uuid === localPic.uuid);
                return updated
                    ? Object.assign(Object.assign({}, localPic), { isUserFavorite: updated.isUserFavorite }) : localPic;
            }));
        }
    }, [pictureSet.pictures, pictureSet.subject.uuid]);
    const handleToggle = (pictureSet, pic, userUuid) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield toggleUserFavoritePicture(pictureSet.subject.uuid, pic.uuid, userUuid);
        }
        catch (_a) {
            console.log("Toggle call");
        }
    });
    if (!user) {
        return React.createElement("div", null, "Loading");
    }
    return (React.createElement(Grid, { container: true, spacing: 2 },
        pictures.map((picture) => (React.createElement(Grid, { key: picture.uuid, size: { xs: 6, sm: 4, md: 3 }, className: classes.listItem },
            React.createElement(Picture, { pictureSet: pictureSet, picture: picture, user: user, openImage: openImage, toggleUserFavoritePicture: handleToggle, pictureContextMenuProps: pictureContextMenuProps })))),
        React.createElement(FullscreenImageDialog, { open: open, onClose: closeImage, transformOrigin: origin, picture: fullscreenImage, actionIcon: fullscreenImage && fullscreenImage.isUserFavorite ? (React.createElement(FavoriteIcon, null)) : (React.createElement(FavoriteBorderIcon, null)), actionText: fullscreenImage && fullscreenImage.isUserFavorite
                ? t("Unmark favorite") || ""
                : t("Mark as favorite") || "", actionHandler: (picture) => {
                handleToggle(pictureSet, picture, user.uuid);
            } })));
};
function Picture({ pictureSet, user, picture, toggleUserFavoritePicture, openImage, pictureContextMenuProps, }) {
    const classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement("img", Object.assign({ src: webshopUserImageUrlCreator(picture.uuid, 320) }, pictureContextMenuProps, { onClick: (e) => openImage(e, picture) })),
        React.createElement(IconButton, { sx: {
                position: "absolute",
                top: 1,
                left: 1,
                color: "secondary.main",
                filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.4))",
            }, onClick: () => toggleUserFavoritePicture(pictureSet, picture, user.uuid) }, picture.isUserFavorite ? React.createElement(FavoriteIcon, null) : React.createElement(FavoriteBorderIcon, null))));
}
export default UserSubjectFavoritePicturesSelector;
